import { takeLatest, put, call, select } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';
import { SELECT_DEALER } from 'constants/ActionTypes';
import { APPOINTMENT_STATUSES, APPOINTMENT_TASK_TYPES } from 'constants/AppointmentConstants';
import { PATH } from 'constants/RoutesConstants';

import { scopeToPage } from 'modules/app/sagas/utils';
import * as actions from 'modules/appointments/actions';
import * as actionTypes from 'modules/appointments/actionTypes';
import {
  getPage,
  getToFilter,
  getSortFilter,
  getTextFilter,
  getFromFilter,
  getTypesFilter,
  getBrandsFilter,
  getStatusFilter,
} from 'modules/appointments/selectors/dashboard';
import { closeSendModal } from 'modules/interventions/actions/details';
import * as interventionActionTypes from 'modules/interventions/actionTypes';
import { getSelectedDealerId } from 'selectors/dealerSelectors';

function* getAll({ payload, meta }) {
  const { request } = payload;
  try {
    const page = yield select(getPage);
    const dealerId = yield select(getSelectedDealerId);
    let brands = yield select(getBrandsFilter);
    const from = yield select(getFromFilter);
    const sort = yield select(getSortFilter);
    const text = yield select(getTextFilter);
    const to = yield select(getToFilter);

    // Transform brands array of objects to array of IDs
    if (brands && brands.length > 0) {
      brands = brands.map(brand => (typeof brand === 'object' ? brand.id : brand));
    }

    let types = yield select(getTypesFilter);
    if (types) {
      types = types.reduce((acc, type) => {
        if (type === APPOINTMENT_TASK_TYPES.KEY_DEPOSIT) {
          acc.keyDeposit = true;
        }

        if (type === APPOINTMENT_TASK_TYPES.KEY_RETRIEVE) {
          acc.keyRetrieve = true;
        }

        return acc;
      }, {});
    }

    let status = yield select(getStatusFilter);
    if (status.length === 0) {
      status = [APPOINTMENT_STATUSES.OPEN, APPOINTMENT_STATUSES.CLOSED];
    }

    request.params = {
      ...page,
      ...types,
      dealerId,
      status,
      brands,
      sort,
      from,
      text,
      to,
      ...request.params,
    };

    if (dealerId) {
      const { data: appointments } = yield call(restClient.request, request);
      yield put(actions.fetchAppointmentsSuccess(appointments, meta));
    }
  } catch (errorMessage) {
    yield put(actions.fetchAppointmentsFailure(errorMessage, meta));
  }
}

function* refreshAll() {
  yield put(actions.fetchAppointments());
}

function* afterUpdateSendBySuccess({ meta = {} }) {
  if (!meta.keepOpen) {
    yield put(closeSendModal());
  }
}

const REFRESH_ACTION_TYPE = [
  SELECT_DEALER,
  actionTypes.SET_APPOINTMENT_FILTER,
  actionTypes.SET_APPOINTMENT_FILTERS,
  actionTypes.CLEAR_APPOINTMENT_FILTERS,
  actionTypes.REMOVE_APPOINTMENT_FILTER,
  actionTypes.CLEAR_PAGE,
  actionTypes.SET_PAGE_SIZE,
];

function* onAppointmentPageWorker() {
  yield call(refreshAll);
  yield takeLatest(REFRESH_ACTION_TYPE, refreshAll);
  yield takeLatest(interventionActionTypes.POST_SEND_BY_SUCCESS, afterUpdateSendBySuccess);
}

export default function* appointmentSagas() {
  yield takeLatest(actionTypes.FETCH_APPOINTMENTS_REQUEST, getAll);
  yield scopeToPage([PATH.KEY_DROP_OFF_APPOINTMENTS], onAppointmentPageWorker);
}
